import React, { useRef, useState } from 'react';

import {
    faMicrophone,
    faMicrophoneSlash,
    faVideo,
    faVideoSlash,
    faPhone,
    faClipboard,
    faChevronDown,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BlurOffIcon from '@mui/icons-material/BlurOff';
import BlurOnIcon from '@mui/icons-material/BlurOn';
import MenuItem from '@mui/material/MenuItem';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';

import MenuButton from 'components/Common/MenuButton/MenuButton';

const VirtualAppointmentsControls = ({
    onClickIconHandler,
    onClickMenuItem,
    enableAudio,
    enableVideo,
    finishVideoCall,
    onlyAudio,
    handleTranslateLink,
    backgroundBlur,
    participants,
}) => {
    const [blurBackgroundEnabled, setBlurBackgroundEnabled] = useState(backgroundBlur ?? false);
    const tooltipRef: any = useRef(null);

    const viewOptionsRef: any = useRef(null);

    const handleHover = () => {
        tooltipRef.current.content = 'Copy invitation link for translator';
    };

    const handleCopyTranslatorLink = async () => {
        await handleTranslateLink();
        tooltipRef.current.content = 'Text is copied!';
    };

    const handleChangeBlurBackgroundEnabled = (event) => {
        onClickIconHandler(event);
        setBlurBackgroundEnabled(!blurBackgroundEnabled);
    };

    const handleMenuItemClick = (selectedItem) => {
        onClickMenuItem(selectedItem);
        viewOptionsRef?.current.closeMenu();
    };

    const viewOptionsItems = () => {
        if (!participants || participants.length === 0) {
            return <span className='view-options__empty'>No participants to display</span>;
        }

        const items = participants.map((participant) => {
            return (
                <MenuItem
                    key={participant.identity}
                    onClick={handleMenuItemClick.bind(this, participant.identity)}
                >
                    {participant.name}
                </MenuItem>
            );
        });

        const gridItem = (
            <MenuItem
                key='grid'
                onClick={handleMenuItemClick.bind(this, 'grid')}
            >
                Grid
            </MenuItem>
        );

        return [gridItem, ...items];
    };

    return (
        <React.Fragment>
            <div
                id='muteIcon'
                className='white-btn'
                onClick={onClickIconHandler}
            >
                {enableAudio ? <FontAwesomeIcon icon={faMicrophone} /> : <FontAwesomeIcon icon={faMicrophoneSlash} />}
            </div>
            {onlyAudio === false ? (
                <div
                    id='videoIcon'
                    className='white-btn'
                    onClick={onClickIconHandler}
                >
                    {enableVideo ? <FontAwesomeIcon icon={faVideo} /> : <FontAwesomeIcon icon={faVideoSlash} />}
                </div>
            ) : null}

            <div
                id='conference-hang-up'
                className='red-btn'
                onClick={finishVideoCall}
            >
                <FontAwesomeIcon icon={faPhone} />
            </div>
            <div onMouseEnter={handleHover}>
                <TooltipComponent
                    ref={tooltipRef}
                    content='Copy invitation link for translator'
                    position='TopCenter'
                >
                    <div
                        id='clipboardIcon'
                        className='white-btn'
                        onClick={handleCopyTranslatorLink}
                    >
                        <FontAwesomeIcon icon={faClipboard} />
                    </div>
                </TooltipComponent>
            </div>
            {onlyAudio === false ? (
                <>
                    <TooltipComponent
                        content='Blur Background'
                        position='TopCenter'
                    >
                        <div
                            className={`white-btn ${!enableVideo ? 'disabled' : ''}`}
                            id='blurSwitch'
                            onClick={handleChangeBlurBackgroundEnabled}
                        >
                            {blurBackgroundEnabled ? <BlurOnIcon fontSize='large' /> : <BlurOffIcon fontSize='large' />}
                        </div>
                    </TooltipComponent>
                </>
            ) : null}
            <MenuButton
                ref={viewOptionsRef}
                buttonContent={() => <FontAwesomeIcon icon={faChevronDown} />}
                classes={{ wrapper: 'white-btn', button: 'view-type-btn' }}
            >
                {viewOptionsItems()}
            </MenuButton>
        </React.Fragment>
    );
};

export default VirtualAppointmentsControls;
